import React from 'react';
import { Modal, Button, Typography } from 'antd';
import { LockOutlined, WarningOutlined } from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const LicenseOverlay = ({ visible, onSettingsClick, isTampered }) => {
  return (
    <Modal
      visible={visible}
      closable={false}
      footer={null}
      width={400}
      centered
      maskClosable={false}
    >
      <div style={{ textAlign: 'center', padding: '20px 0' }}>
        {isTampered ? (
          <WarningOutlined style={{ fontSize: 48, color: '#ff4d4f', marginBottom: 24 }} />
        ) : (
          <LockOutlined style={{ fontSize: 48, color: '#1890ff', marginBottom: 24 }} />
        )}
        <Title level={3}>{isTampered ? 'License Verification Failed' : 'Premium License Required'}</Title>
        <Paragraph>
          {isTampered
            ? 'Your license verification failed. This may be due to an error or unauthorized modifications. Please make sure you are using an official version of the plugin with a valid license key'
            : 'You need a valid license to access this feature. Please enter your license key or purchase a license to continue.'}
        </Paragraph>
        <Button type="primary" onClick={onSettingsClick}>
          {isTampered ? 'Go to Settings' : 'Enter License Key'}
        </Button>
        {!isTampered && (
          <Button type="link" href="https://wpaiworkflowautomation.com/#pricing" target="_blank" style={{ marginLeft: 8 }}>
            Purchase License
          </Button>
        )}
      </div>
    </Modal>
  );
};

export default LicenseOverlay;